import {
    LIST_DRAW_RESULT_TN,
    FETCH_DRAW_RESULT_TN,
    MODIFY_DRAW_RESULT_TN, CLEAR_DRAW_RESULT_TN,
} from "./types";

const init = {
    isLoading: false,
    filter: {},
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_DRAW_RESULT_TN:
            return {
                ...state,
                filter: payload,
                isLoading: false
            };
        case LIST_DRAW_RESULT_TN:
            return {
                ...state,
                isLoading: false,
               ...payload

            };
        case MODIFY_DRAW_RESULT_TN:
            return {
                ...state,
                isLoading: true

            };
        case CLEAR_DRAW_RESULT_TN:
            return {
                ...init
            };

        default:
            return state;
    }
}